import React from 'react';
import { Checkbox } from '../ui/checkbox';

const TONI = {
  green: {
    box: 'border-green-400 lg:border-green-600 data-[state=checked]:bg-green-600 data-[state=checked]:border-green-600 text-white',
    btn: 'bg-green-600 hover:bg-green-700 shadow-green-600/30',
  },
  red: {
    box: 'border-red-400 lg:border-red-600 data-[state=checked]:bg-red-600 data-[state=checked]:border-red-600 text-white',
    btn: 'bg-red-600 hover:bg-red-700 shadow-red-600/30',
  },
};

export const SelezioneCheckbox = ({ checked, onToggle, tone, testid }) => (
  <div onClick={(e) => e.stopPropagation()} className="flex items-center p-1 -m-1">
    <Checkbox
      checked={checked}
      onCheckedChange={onToggle}
      aria-label="Seleziona etichetta"
      data-testid={testid}
      className={`h-5 w-5 rounded-md transition-colors ${TONI[tone].box}`}
    />
  </div>
);

export const SelezioneBar = ({ tone, total, selected, onToggleAll, onAction, actionLabel, ActionIcon, busy, testidPrefix }) => {
  const allSelected = total > 0 && selected === total;
  return (
    <div
      data-testid={`${testidPrefix}-selezione-bar`}
      className="sticky top-0 haccp-sticky-bar z-20 flex items-center justify-between gap-3 mb-3 px-3 py-2.5 rounded-xl border bg-slate-900/90 border-slate-700/50 lg:bg-white lg:border-gray-200"
    >
      <label className="flex items-center gap-2.5 cursor-pointer select-none min-w-0">
        <Checkbox
          checked={allSelected}
          onCheckedChange={onToggleAll}
          data-testid={`${testidPrefix}-seleziona-tutte`}
          className={`h-5 w-5 rounded-md transition-colors ${TONI[tone].box}`}
        />
        <span className="text-sm font-medium text-white lg:text-gray-800">
          {allSelected ? 'Deseleziona tutte' : 'Seleziona tutte'}
        </span>
        <span data-testid={`${testidPrefix}-contatore`} className="text-xs text-slate-400 lg:text-gray-500 truncate">
          {selected}/{total}
        </span>
      </label>
      <button
        onClick={onAction}
        disabled={selected === 0 || busy}
        data-testid={`${testidPrefix}-azione-btn`}
        className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-white text-xs sm:text-sm font-medium shadow-lg transition-[background-color,opacity,transform] active:scale-95 disabled:opacity-40 disabled:shadow-none disabled:cursor-not-allowed ${TONI[tone].btn}`}
      >
        {busy ? <span className="h-4 w-4 rounded-full border-2 border-white/40 border-t-white animate-spin" /> : <ActionIcon className="h-4 w-4" />}
        <span className="hidden sm:inline">{actionLabel}</span>
        <span>({selected})</span>
      </button>
    </div>
  );
};
